import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Icon, Card, message } from "antd";
import { OrderedMap, Map } from "immutable";
import { INPUT_TYPES } from "constants";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import moment from "moment";
import "styles/data-sync-form.css";
// import CompanyLosService from "./../services/company-los-services";

export const BASE_URL = (function() {
    return process.env.BASE_URL;
})();

const SECTIONS = new OrderedMap({
    1: {
        label: "Distributor ERP"
    },
    2: {
        label: "Company Person Detail"
    },
    3: {
        label: "Company Person Availability"
    },
    4: {
        label: "Upload"
    }
});

class DataSyncForm extends React.Component {
    state = {
        brandIds: new Map({}),
        removedBrands: [],
        addedBrands: false,
    };

    onRemove = _ => {
        if (this.props.form.getFieldValue("files")) {
            let files = this.props.form.getFieldValue("files").filter(file => file.uid !== _.uid);
            this.props.form.setFieldsValue({
                "files": files
            });
        } else {
            this.props.form.setFieldsValue({
                "files": null
            });
        }
    }

    beforeUpload = (_) => {
        let files = [];
        const existingFiles = this.props.form.getFieldValue("files");
        const isFileType = _.type === "application/pdf" || _.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || _.type === "application/vnd.ms-excel";
        if (!isFileType) {
            message.error("You can only upload pdf or excel file!");
        }
        const isLt2M = _.size / 1024 / 1024 < 20;
        if (!isLt2M) {
            message.error("File must be smaller than 20MB!");
        }
        if (existingFiles && isFileType && isLt2M) {
            files = [...existingFiles, _];
        } else if (isFileType && isLt2M) {
            files.push(_);
        }
        if(isFileType && isLt2M){
            this.props.form.setFieldsValue({
                "files": files
            });
        }
        return false;
    }

    getFormFields = (
        // {
        // allFieldsDisabled
        // }
    ) => new OrderedMap({
        erp_software: {
            key: "erp_software",
            label: "ERP Software",
            type: INPUT_TYPES.OBJECT_SELECT,
            className: "form-field fb-30 mr-10",
            labelProp: "name",
            required: true,
            category: 1,
            rules: [{
                required: true,
            }]
        },
        request_type: {
            key: "request_type",
            label: "'Sync' Availability",
            type: INPUT_TYPES.OBJECT_SELECT,
            className: "form-field fb-30 mr-10",
            defaultValue: { id: 1, name: "Yes" },
            labelProp: "name",
            options: [
                {
                    id: 1,
                    name: "Yes"
                },
                {
                    id: 2,
                    name: "No"
                }
            ],
            category: 1,
            rules: [{
                required: true,
            }]
        },
        erp_name: {
            key: "erp_name",
            label: "ERP Name",
            type: INPUT_TYPES.TEXT,
            className: "form-field fb-30 mr-30",
            category: 1
        },
        contact_person: {
            key: "contact_person",
            label: "Select Contact Person",
            type: INPUT_TYPES.OBJECT_SELECT,
            className: "form-field fb-30 mr-10",
            labelProp: "name",
            onSelect: this.onContactPersonSelect,
            category: 2,
        },
        first_name: {
            key: "first_name",
            label: "First Name",
            type: INPUT_TYPES.TEXT,
            className: "form-field fb-30 mr-10",
            category: 2,
        },
        last_name: {
            key: "last_name",
            label: "Last Name",
            type: INPUT_TYPES.TEXT,
            className: "form-field fb-30 mr-10",
            category: 2,
        },
        designation: {
            key: "designation",
            label: "Designation",
            type: INPUT_TYPES.OBJECT_SELECT,
            className: "form-field fb-30 mr-10",
            labelProp: "label",
            options: [
                { label: "Proprietor", id: 1 },
                { label: "Partner", id: 2 },
                { label: "Director", id: 3 },
                { label: "Karta", id: 4 },
                { label: "Management", id: 5 },
                { label: "Accountant", id: 6 },
                { label: "Other", id: 7 }
            ],
            category: 2,
            rules: [{
                required: true,
            }]
        },
        phone: {
            key: "phone",
            label: "Mobile Number",
            type: INPUT_TYPES.TEXT,
            className: "form-field fb-30 mr-10",
            category: 2,
            rules: [
                {
                    required: true,
                    message: "Mobile Number is Required"
                },
                {
                    min: 10,
                    message: "Enter valid mobile number "
                },
                {
                    max: 10,
                    message: "Enter valid mobile number "
                },
                {
                    pattern: /^(?:\d*)$/,
                    message: "Value should contain just number",
                },
            ]
        },
        date: {
            key: "date",
            label: "Date",
            type: INPUT_TYPES.DATE,
            className: "form-field fb-30 mr-10",
            category: 3,
            disabledDate: current => {
                return current < moment().startOf("day");
            },
            rules: [{
                required: true,
            }]
        },
        time: {
            key: "time",
            label: "Time",
            type: INPUT_TYPES.TIME,
            className: "form-field fb-30",
            category: 3,
            minuteStep: 30,
            rules: [{
                required: true,
            }]
        },
        files: {
            key: "files",
            multiple: true,
            action: null,
            showUploadList: false,
            beforeUpload: this.beforeUpload,
            label: "Upload Ledgers",
            type: INPUT_TYPES.DRAGGABLEUPLOADER,
            className: "form-field fb-30 mr-10 multiple-file",
            accept: "application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            title: "Upload Files",
            category: 4,
            onRemove: this.onRemove,
            rules: [ {
                required: true,
            }]
        },
        mapping: {
            key: "mapping",
            multiple: false,
            showUploadList: false,
            label: "Upload GSTIN Ledger Mapping",
            type: INPUT_TYPES.FILE,
            className: "form-field fb-30",
            accept: "application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            btnLabel: "Upload File",
            category: 4,
            rules: [{
                required: true,
            }]
        }
    });
    fields = {
        seller: "Distributor Name",
        erp_software: "ERP Software",
        erp_name: "ERP Name",
        designation: "Designation",
        date: "Date",
        time: "Time",
        files: "Ledger"
    }; 
    onContactPersonSelect = (_) => {
        if (_.id) {
            const contact_person = this.props.associates.find(__ => __.id === _.id);
            this.props.form.setFieldsValue({
                contact_person: _,
                first_name: contact_person.first_name,
                last_name: contact_person.last_name,
                designation: contact_person.title,
                phone: contact_person.phone
            });
        } else {
            this.props.form.setFieldsValue({
                contact_person: undefined,
                first_name: undefined,
                last_name: undefined,
                designation: undefined,
                phone: undefined
            });
        }
    }

    formFields = this.getFormFields({ allFieldsDisabled: this.props.loading });
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = e => {
        e.preventDefault();
        let files = this.props.form.getFieldValue("files");
        let uploadedExtensionList = [];
        let fileName = []
        files?.map((item) => {
            uploadedExtensionList.push(item?.type);
            fileName.push(item?.name);
        });
        let diffExtension = !uploadedExtensionList.every( (val, i, arr) => val === uploadedExtensionList[0] );
        function hasDuplicates(arr) {
            var counts = [];
        
            for (var i = 0; i <= arr.length; i++) {
                if (counts[arr[i]] === undefined) {
                    counts[arr[i]] = 1;
                } else {
                    return true;
                }
            }
            return false;
        }
        if (!this.props.loading) {
            this.props.form.validateFields((err, values) => {
                if (!err) {
                    if(diffExtension){
                        message.error("Please upload files of only one type (pdf or excel):)");
                    }else if(hasDuplicates(fileName)){
                        message.error("Multiple files have the same name, please ensure all file names are different");
                    }else{
                        this.props.onSubmit(values);
                    }
                }
            });
        }
    }

    render() {
        return (
            <Form onSubmit={this.onValuesSubmit}>
                <div className={"form-row justify-content-center w-100"}>
                    {this.formFields
                        .groupBy(_ => _.category)
                        .map((__, category) => {
                            if (
                                this.props.form.getFieldValue("erp_software") &&
                                !this.props.form.getFieldValue("erp_software").is_sync_possible &&
                                (category === 2 || category === 3)
                            ) {
                                return;
                            }
                            if (
                                (this.props.form.getFieldValue("request_type") &&
                                    this.props.form.getFieldValue("request_type").id === 2) &&
                                (category === 2 || category === 3)
                            ) {
                                return;
                            }
                            if (
                                this.props.form.getFieldValue("erp_software") &&
                                this.props.form.getFieldValue("erp_software").is_sync_possible &&
                                this.props.form.getFieldValue("request_type") &&
                                this.props.form.getFieldValue("request_type").id === 1 &&
                                category === 4
                            ) {
                                return;
                            }
                            if (
                                !this.props.form.getFieldValue("erp_software") &&
                                !this.props.form.getFieldValue("request_type") &&
                                category === 4
                            ) {
                                return;
                            }
                            if (
                                this.props.form.getFieldValue("erp_software") &&
                                this.props.form.getFieldValue("erp_software").is_sync_possible &&
                                !this.props.form.getFieldValue("request_type") &&
                                category === 4
                            ) {
                                return;
                            }
                            return <div key={category} className={"w-70 pt-10"}>
                                <h3 className={"pt-5 pb-5"}>{SECTIONS.find((section, k) => k == category).label}</h3>
                                <Card className={"no-shadow border-none"}>
                                    <div className={"d-flex flex-row flex-wrap w-100"}>
                                        {__.map((field, fieldName) => {
                                            if (fieldName === "erp_software") {
                                                field.options = this.props.master_erps;
                                            }
                                            if (fieldName === "request_type") {
                                                if (
                                                    this.props.form.getFieldValue("erp_software") &&
                                                    !this.props.form.getFieldValue("erp_software").is_sync_possible
                                                ) {
                                                    return;
                                                }
                                            }
                                            if(fieldName === "erp_name") {
                                                const erp = this.props.form.getFieldValue("erp_software");
                                                if(!erp || (erp && erp.key !== "other")) {
                                                    return;
                                                }
                                            }
                                            if (
                                                category === 2 &&
                                                fieldName !== "contact_person" &&
                                                this.props.form.getFieldValue("contact_person") &&
                                                this.props.form.getFieldValue("contact_person").id
                                            ) {
                                                field.rules = null;
                                                field.disabled = true;
                                            } else {
                                                field.rules = [{
                                                    required: true,
                                                }];
                                                field.disabled = false;
                                            }
                                            if(fieldName === "contact_person"){
                                                field.rules = [
                                                    {
                                                        required: false
                                                    }
                                                ];  
                                            }
                                            if(fieldName === "first_name"){
                                                field.rules = [
                                                    {
                                                        required: true,
                                                        message: "First Name is Required"
                                                    },
                                                    {
                                                        //eslint-disable-next-line
                                                        pattern: /^[A-Za-z]+$/,
                                                        message: "Enter valid Name"
                                                    }
                                                ];
                                            }
                                            if(fieldName ==="last_name"){
                                                field.rules = [
                                                    {
                                                        required: true,
                                                        message: "Last Name is Required"
                                                    },
                                                    {
                                                        //eslint-disable-next-line
                                                        pattern: /^[A-Za-z]+$/,
                                                        message: "Enter valid Name"
                                                    }
                                                ];
                                            }
                                            if(fieldName ==="phone"){
                                                field.rules = [
                                                    {
                                                        required: true,
                                                        message: "Mobile Number is Required"
                                                    },
                                                    {
                                                        min: 10,
                                                        message: "Enter valid mobile number"
                                                    },
                                                    {
                                                        max: 10,
                                                        message: "Enter valid mobile number"
                                                    },
                                                    {
                                                        pattern: /^(?:\d*)$/,
                                                        message: "Value should contain just number",
                                                    },
                                                ],
                                                field.disabled = false;
                                            }
                                            if (fieldName === "contact_person") {
                                                field.options = [{ name: "Select Person" }, ...this.props.associates];
                                                if (
                                                    this.props.form.getFieldValue("first_name") &&
                                                    this.props.form.getFieldValue("last_name") &&
                                                    this.props.form.getFieldValue("phone") &&
                                                    this.props.form.getFieldValue("designation") &&
                                                    this.props.form.getFieldValue("designation").id
                                                ) {
                                                    field.rules = null;
                                                    field.disabled = true;
                                                }
                                                return <div key={fieldName} className={"d-flex flex-column w-100"}>
                                                    <div className={"w-30"}>
                                                        {this.fieldGenerator(
                                                            fieldName,
                                                            field,
                                                            this.getValidateStatus(fieldName)
                                                        )()}
                                                    </div>
                                                    <span className={"mb-10"} style={{
                                                        fontSize: "18px",
                                                        fontWeight: 500
                                                    }}>or</span>
                                                </div>;
                                            }
                                            if(fieldName === "time"){
                                                var currentTime = moment().format("HH:mm");
                                                field.disabledHours = () => {
                                                    var hours = [];
                                                    for(var i =0; i <= moment().hour(); i++){
                                                        hours.push(i);
                                                    }
                                                    if(this.props.form.getFieldValue("date")?.format("DD/MM/YYYY") == moment(new Date()).format("DD/MM/YYYY")){
                                                        if(currentTime.split(":")[1] > 30){
                                                            return hours;
                                                        }else{
                                                            hours.pop();
                                                            return hours;
                                                        }
                                                    }
                                                    return null;
                                                };
                                                field.disabledMinutes = () => {
                                                    var minutes = [];
                                                    for(var i =0; i < moment().minutes(); i++){
                                                        minutes.push(i);
                                                    }
                                                    if(this.props.form.getFieldValue("date")?.format("DD/MM/YYYY") == moment(new Date()).format("DD/MM/YYYY") && this.props.form.getFieldValue("time")?.format("HH") == moment().hour()){
                                                        return minutes;
                                                    }
                                                    return null;
                                                };
                                            }
                                            if(fieldName === "date"){
                                                var currentTimee = moment().format("HH:mm");
                                                if((this.props.form.getFieldValue("time")?.format("HH") < moment().hour() || (this.props.form.getFieldValue("time")?.format("HH") == moment().hour() && this.props.form.getFieldValue("time")?.format("mm") < currentTimee?.split(":")[1]))&& this.props.form.getFieldValue("date")?.format("DD/MM/YYYY") == moment(new Date()).format("DD/MM/YYYY")){
                                                    this.props.form.setFieldsValue({
                                                        "time": null
                                                    });
                                                }
                                            }
                                            Object.keys(this.fields).map(el => {
                                                // console.log(this.fields[el]);
                                                if(fieldName === el){
                                                    return(
                                                        field.rules = [
                                                            {
                                                                required: true,
                                                                message: `${this.fields[el]} is Required`
                                                            }
                                                        ]
                                                    );
                                                }
                                            });
                                            if(fieldName === "mapping"){
                                                return (<React.Fragment>{this.fieldGenerator(
                                                    fieldName,
                                                    field,
                                                    this.getValidateStatus(fieldName)
                                                )()}{
                                                    <div className={"d-flex flex-column"}>
                                                        <h3 style={{fontSize: "14px", color: "rgba(0, 0, 0, 0.85)", fontWeight: "normal"}}>Download Sample File:</h3>
                                                        <Button style={{
                                                            color: "#45BE93",
                                                            border: "0.6px solid #45BE93"
                                                        }} type={"default"} shape={"round"}>
                                                            <a style={{ color: "rgb(69, 190, 147) !important" }} target={"_blank"} rel="noopener noreferrer" href={BASE_URL + "/company/ledger_mapping_sample"}>Sample File <Icon type={"download"} /></a>
                                                        </Button>
                                                    </div>
                                                }</React.Fragment>);
                                            }
                                            return this.fieldGenerator(
                                                fieldName,
                                                field,
                                                this.getValidateStatus(fieldName)
                                            )();
                                        }).toList()}
                                        {
                                            (
                                                category === 1 &&
                                                this.props.form.getFieldValue("erp_software") &&
                                                this.props.form.getFieldValue("erp_software").is_sync_possible &&
                                                this.props.form.getFieldValue("request_type") &&
                                                this.props.form.getFieldValue("request_type").id === 2
                                            ) ?
                                                <div className={"fb-30 ml-05"}>
                                                    <span style={{
                                                        color: "#FF808B"
                                                    }}>We recommend you convince your distributor to do Tally sync instead of sharing ledgers offline. This will be sent for approval to your state head and Line Manager if you still wish to go ahead with manual ledger upload</span>
                                                </div>
                                                : null
                                        }
                                    </div>
                                </Card>
                            </div>;
                        }).toList()
                    }
                </div>
                <div className={"form-row justify-content-center mt-10"}>
                    <div className={"w-70 flex-row-reverse"}>
                        <Button type={"primary"} htmlType={"submit"}>
                            {this.props.loading ? <Icon type={"loading"} /> : null}
                            Add/Update
                        </Button>
                    </div>
                </div>
            </Form>
        );
    }
}

DataSyncForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.array,
    onValuesSubmit: PropTypes.func,
    loading: PropTypes.bool,
    visible: PropTypes.bool,
    toggleBrandModal: PropTypes.func,
    master_erps: PropTypes.array,
    associates: PropTypes.array,
    onSubmit: PropTypes.func,
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
            values
                .map((value) => {
                    let message = null;
                    if (value === null) {
                        message = "Field cannot be empty";
                    }
                    if (message) {
                        return Form.createFormField({
                            value,
                            errors: [{ message }]
                        });
                    } else {
                        return Form.createFormField({
                            value
                        });
                    }
                }).toJS();
    }
})(DataSyncForm);